import React, {useCallback, useEffect, useMemo, useState} from "react";
import {message, Modal, ConfigProvider} from "antd";
import moment from "moment-timezone";
import DeliveryProviderInvoiceTable from "../DeliveryProviderInvoiceTable/DeliveryProviderInvoiceTable";
import {useRequest} from "../../../utils/hooks";
import {HttpClient} from "../../../http/HttpClient";
import {DeliveryProviderDeliveriesProjection} from "../../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/consts";

const AdminDeliveryProviderMonthDeliveriesModal = ({
    deliveryProviderId,
    visible,
    onCancel,
    addInvoice,
    month,
    invoices = []
}) => {
    const [selectedMonth, setSelectedMonth] = useState(moment().subtract(1, "month"));

    useEffect(() => {
        if (month) {
            setSelectedMonth(month);
        }
    }, [month]);

    const uploadInvoice = useCallback(
        async invoice => {
            const newInvoice = await HttpClient.safePut("/admin/api/deliveryProviderInvoice/createInvoice", {
                deliveryProviderId,
                ...invoice
            });

            if (newInvoice.error) {
                message.error("תקלה ביצירת חשבונית");
                return;
            }

            addInvoice(newInvoice);
        },
        [deliveryProviderId, addInvoice]
    );

    const deleteInvoice = useCallback(async (invoiceId, invoiceDeliveryProviderId) => {
        const {error} = await HttpClient.safeDelete(
            `/admin/api/deliveryProviderInvoice/${invoiceDeliveryProviderId}/${invoiceId}`
        );

        if (error) {
            message.error("שגיאה בעת מחיקת חשבונית");
            return;
        }

        message.success("חשבונית נמחקה בהצלחה");
    }, []);

    const [deliveriesResponse, loadingDeliveries] = useRequest(
        `/admin/api/deliveryProviders/${deliveryProviderId}/deliveries`,
        "POST",
        {
            startDate: selectedMonth.clone().startOf("month").valueOf(),
            endDate: selectedMonth.clone().endOf("month").valueOf(),
            projection: DeliveryProviderDeliveriesProjection,
            pageSize: 1000,
            page: 1
        },
        [selectedMonth],
        !!selectedMonth && !!deliveryProviderId
    );

    return (
        <ConfigProvider direction="rtl">
            <Modal
                className="admin-delivery-provider-month-invoices-modal"
                width="90vw"
                destroyOnClose={true}
                open={visible}
                onCancel={onCancel}
                footer={null}
                title={null}>
                <DeliveryProviderInvoiceTable
                    deliveries={deliveriesResponse?.deliveries || []}
                    loadingDeliveries={loadingDeliveries}
                    selectedMonth={selectedMonth}
                    setSelectedMonth={setSelectedMonth}
                    uploadInvoice={uploadInvoice}
                    invoices={invoices ?? []}
                    logsURI={`/admin/api/deliveryProviderInvoiceLog/deliveryProviderId/${deliveryProviderId}/byMonth/${selectedMonth.format(
                        "MM-YYYY"
                    )}`}
                    deleteInvoice={deleteInvoice}
                />
            </Modal>
        </ConfigProvider>
    );
};

export default AdminDeliveryProviderMonthDeliveriesModal;
